import { AbstractControl } from '@angular/forms';;
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BatteryDateCodeValidation {

  constructor() {}

  static ValidateBatteryDateCode = () => {
    return (control: AbstractControl) => {
      const rex: RegExp = /^(1[0-2]|0[1-9])([0-9][0-9])$/;
      if (control.value !== ''
          && control.value !== null
          && control.value !== undefined
          && !rex.test(control.value)
        ) {
        return { validateBatteryDateCode: true }
      }
      return null;
    }
  }
}
